import { array, number, object, } from 'yup';
const priceBand = object({
    PriceBandId: number().required(),
    Units: number().required(),
});
export const miscProductsSchema = object({
    MiscellaneousId: number(),
    PriceBands: array(priceBand),
});
